export const PNG_SIGNATURE = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]);

export interface PngChunk {
  offset: number;
  length: number;
  type: string;
  typeBytes: Uint8Array;
  dataStart: number;
  dataEnd: number;
  crcOffset: number;
}

export function isPngSignature(buf: Uint8Array): boolean {
  if (buf.length < 8) return false;
  for (let i = 0; i < 8; i++) {
    if (buf[i] !== PNG_SIGNATURE[i]) return false;
  }
  return true;
}

export function* iterPngChunks(buf: Uint8Array): Generator<PngChunk> {
  if (!isPngSignature(buf)) {
    throw new Error('不是有效 PNG/APNG（签名不匹配）');
  }
  const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
  let offset = 8;
  const n = buf.length;
  while (offset + 12 <= n) {
    const length = view.getUint32(offset);
    const typeStart = offset + 4;
    const dataStart = offset + 8;
    const dataEnd = dataStart + length;
    const crcOffset = dataEnd;
    if (crcOffset + 4 > n) {
      throw new Error(`chunk 越界 @ ${offset}`);
    }
    const typeBytes = buf.subarray(typeStart, typeStart + 4);
    const type = String.fromCharCode(
      typeBytes[0]!,
      typeBytes[1]!,
      typeBytes[2]!,
      typeBytes[3]!,
    );
    yield {
      offset,
      length,
      type,
      typeBytes,
      dataStart,
      dataEnd,
      crcOffset,
    };
    offset = crcOffset + 4;
    if (type === 'IEND') break;
  }
}
